import styled, {css} from "styled-components";

const ManageDeliveryStyled = styled.div`
   width: 100%;
   height: 100%;
   background: white;
   padding: 20px;
   display: flex;
   flex-direction: column;
   gap: 20px;
   justify-content: flex-start;
   align-items: center;

   .textNotes {
      font-size: 1.2rem;
      color: #3D4543;
   }

   b {
      font-size: 1.2rem;
      color: #3D4543;
   }

   @media only screen and (min-width: ${props => props.theme.desktop}) {
      margin-top: 40px;
      border-radius: 16px;

  }

  .mobileBackWrapper {
   display: flex;
   gap: 8px;
   align-items: center;
   cursor: pointer;
   font-size: 1.4rem;
   font-weight: 700;
   color: #008755;
   width: 100%;

   }

   ${props => {
        return (
            props.exist && !props.apiError &&
            css`
               background: #F3F3F3;
            `
        );
    }}

`

export { ManageDeliveryStyled };
